{
  "version": 1,
  "gridPixels": 16,
  "areas": [
    {
      "id": "silt-stair",
      "name": "The Silt Stair",
      "image": "/assets/painted/silt-stair.webp",
      "width": 1536,
      "height": 1024,
      "spawn": [
        400,
        592
      ],
      "arrival": [
        1408,
        400
      ],
      "opening": { "boat": [[590, 792], [642, 760]], "view": [560, 760] },
      "walkable": [
        [
          [
            64,
            578
          ],
          [
            125,
            566
          ],
          [
            273,
            556
          ],
          [
            409,
            552
          ],
          [
            440,
            546
          ],
          [
            496,
            548
          ],
          [
            512,
            556
          ],
          [
            560,
            618
          ],
          [
            640,
            628
          ],
          [
            704,
            620
          ],
          [
            768,
            628
          ],
          [
            836,
            640
          ],
          [
            870,
            700
          ],
          [
            930,
            740
          ],
          [
            960,
            760
          ],
          [
            1010,
            792
          ],
          [
            1048,
            832
          ],
          [
            1050,
            856
          ],
          [
            961,
            852
          ],
          [
            810,
            791
          ],
          [
            654,
            736
          ],
          [
            507,
            690
          ],
          [
            375,
            654
          ],
          [
            252,
            638
          ],
          [
            131,
            620
          ],
          [
            64,
            612
          ]
        ],
        [
          [
            867,
            754
          ],
          [
            940,
            770
          ],
          [
            972,
            745
          ],
          [
            962,
            671
          ],
          [
            906,
            650
          ],
          [
            891,
            614
          ],
          [
            827,
            566
          ],
          [
            804,
            523
          ],
          [
            773,
            494
          ],
          [
            743,
            506
          ],
          [
            749,
            553
          ],
          [
            785,
            579
          ],
          [
            812,
            609
          ],
          [
            850,
            643
          ],
          [
            881,
            659
          ],
          [
            884,
            716
          ]
        ],
        [
          [
            613,
            415
          ],
          [
            651,
            425
          ],
          [
            686,
            452
          ],
          [
            723,
            455
          ],
          [
            780,
            487
          ],
          [
            767,
            521
          ],
          [
            727,
            494
          ],
          [
            683,
            480
          ],
          [
            650,
            461
          ],
          [
            620,
            450
          ]
        ],
        [
          [
            604,
            411
          ],
          [
            636,
            402
          ],
          [
            682,
            431
          ],
          [
            781,
            444
          ],
          [
            837,
            461
          ],
          [
            905,
            451
          ],
          [
            937,
            416
          ],
          [
            963,
            414
          ],
          [
            1003,
            447
          ],
          [
            1051,
            472
          ],
          [
            1147,
            475
          ],
          [
            1142,
            503
          ],
          [
            1040,
            502
          ],
          [
            944,
            480
          ],
          [
            837,
            486
          ],
          [
            775,
            471
          ],
          [
            681,
            455
          ],
          [
            619,
            435
          ]
        ],
        [
          [
            880,
            440
          ],
          [
            905,
            380
          ],
          [
            930,
            360
          ],
          [
            960,
            352
          ],
          [
            1000,
            370
          ],
          [
            1010,
            410
          ],
          [
            1000,
            445
          ],
          [
            960,
            460
          ]
        ],
        [
          [
            1108,
            460
          ],
          [
            1155,
            450
          ],
          [
            1230,
            467
          ],
          [
            1340,
            498
          ],
          [
            1470,
            532
          ],
          [
            1518,
            536
          ],
          [
            1520,
            570
          ],
          [
            1459,
            572
          ],
          [
            1355,
            538
          ],
          [
            1230,
            504
          ],
          [
            1130,
            488
          ]
        ],
        [
          [
            1476,
            537
          ],
          [
            1514,
            534
          ],
          [
            1516,
            467
          ],
          [
            1477,
            451
          ],
          [
            1452,
            473
          ],
          [
            1479,
            493
          ]
        ],
        [
          [
            1055,
            210
          ],
          [
            1110,
            218
          ],
          [
            1170,
            258
          ],
          [
            1255,
            291
          ],
          [
            1357,
            328
          ],
          [
            1465,
            360
          ],
          [
            1535,
            380
          ],
          [
            1535,
            469
          ],
          [
            1434,
            435
          ],
          [
            1346,
            405
          ],
          [
            1261,
            370
          ],
          [
            1169,
            333
          ],
          [
            1110,
            291
          ],
          [
            1061,
            257
          ]
        ],
        [
          [
            440,
            300
          ],
          [
            500,
            292
          ],
          [
            560,
            300
          ],
          [
            566,
            330
          ],
          [
            540,
            345
          ],
          [
            560,
            375
          ],
          [
            575,
            398
          ],
          [
            610,
            410
          ],
          [
            618,
            432
          ],
          [
            590,
            440
          ],
          [
            548,
            420
          ],
          [
            525,
            395
          ],
          [
            500,
            370
          ],
          [
            470,
            345
          ],
          [
            440,
            330
          ]
        ]
      ],
      "blocked": [
        [
          [
            423,
            603
          ],
          [
            472,
            607
          ],
          [
            493,
            628
          ],
          [
            490,
            657
          ],
          [
            449,
            645
          ],
          [
            426,
            624
          ]
        ],
        [
          [
            558,
            648
          ],
          [
            611,
            648
          ],
          [
            643,
            670
          ],
          [
            643,
            700
          ],
          [
            603,
            698
          ],
          [
            559,
            678
          ]
        ],
        [
          [
            711,
            700
          ],
          [
            751,
            700
          ],
          [
            778,
            724
          ],
          [
            776,
            755
          ],
          [
            735,
            748
          ],
          [
            709,
            722
          ]
        ],
        [
          [
            781,
            651
          ],
          [
            820,
            648
          ],
          [
            838,
            670
          ],
          [
            832,
            700
          ],
          [
            794,
            693
          ]
        ]
      ],
      "foregrounds": [
        {
          "polygon": [
            [
              423,
              603
            ],
            [
              454,
              601
            ],
            [
              488,
              619
            ],
            [
              495,
              649
            ],
            [
              490,
              657
            ],
            [
              449,
              645
            ],
            [
              426,
              624
            ]
          ],
          "depth": 651
        },
        {
          "polygon": [
            [
              558,
              648
            ],
            [
              611,
              648
            ],
            [
              643,
              670
            ],
            [
              643,
              700
            ],
            [
              603,
              698
            ],
            [
              559,
              678
            ]
          ],
          "depth": 701
        },
        {
          "polygon": [
            [
              711,
              700
            ],
            [
              751,
              700
            ],
            [
              778,
              724
            ],
            [
              776,
              755
            ],
            [
              735,
              748
            ],
            [
              709,
              722
            ]
          ],
          "depth": 756
        },
        {
          "polygon": [
            [
              881,
              675
            ],
            [
              881,
              659
            ],
            [
              916,
              649
            ],
            [
              947,
              663
            ],
            [
              951,
              699
            ],
            [
              946,
              710
            ],
            [
              905,
              713
            ]
          ],
          "depth": 719
        },
        {
          "polygon": [
            [
              263,
              553
            ],
            [
              273,
              553
            ],
            [
              330,
              574
            ],
            [
              330,
              584
            ],
            [
              270,
              564
            ],
            [
              263,
              561
            ]
          ],
          "depth": 617
        },
        {
          "polygon": [
            [
              263,
              574
            ],
            [
              331,
              598
            ],
            [
              331,
              606
            ],
            [
              263,
              582
            ]
          ],
          "depth": 617
        },
        {
          "polygon": [
            [
              298,
              557
            ],
            [
              305,
              556
            ],
            [
              310,
              559
            ],
            [
              309,
              599
            ],
            [
              304,
              604
            ],
            [
              297,
              601
            ]
          ],
          "depth": 617
        },
        {
          "polygon": [
            [
              329,
              569
            ],
            [
              336,
              567
            ],
            [
              341,
              570
            ],
            [
              342,
              609
            ],
            [
              339,
              615
            ],
            [
              333,
              616
            ],
            [
              329,
              613
            ]
          ],
          "depth": 617
        },
        {
          "polygon": [
            [
              315,
              577
            ],
            [
              320,
              579
            ],
            [
              320,
              609
            ],
            [
              317,
              612
            ],
            [
              313,
              610
            ]
          ],
          "depth": 617
        }
      ],
      "lamps": [
        [
          138,
          426
        ],
        [
          186,
          564
        ],
        [
          366,
          467
        ],
        [
          582,
          574
        ],
        [
          698,
          614
        ],
        [
          669,
          699
        ],
        [
          818,
          761
        ],
        [
          882,
          670
        ],
        [
          966,
          626
        ],
        [
          813,
          543
        ],
        [
          759,
          479
        ],
        [
          630,
          410
        ],
        [
          712,
          391
        ],
        [
          858,
          413
        ],
        [
          914,
          397
        ],
        [
          992,
          426
        ],
        [
          1108,
          214
        ],
        [
          1181,
          252
        ],
        [
          1314,
          316
        ],
        [
          1434,
          359
        ],
        [
          440,
          866
        ],
        [
          421,
          265
        ],
        [
          344,
          233
        ]
      ],
      "water": [
        [
          [
            30,
            871
          ],
          [
            192,
            983
          ],
          [
            615,
            1023
          ],
          [
            1040,
            1023
          ],
          [
            1047,
            902
          ],
          [
            903,
            890
          ],
          [
            774,
            844
          ],
          [
            730,
            873
          ],
          [
            618,
            826
          ],
          [
            519,
            842
          ],
          [
            489,
            944
          ],
          [
            303,
            913
          ],
          [
            163,
            842
          ]
        ],
        [
          [
            575,
            256
          ],
          [
            646,
            254
          ],
          [
            708,
            262
          ],
          [
            766,
            280
          ],
          [
            803,
            303
          ],
          [
            745,
            325
          ],
          [
            672,
            314
          ],
          [
            603,
            291
          ]
        ],
        [
          [
            1268,
            803
          ],
          [
            1344,
            822
          ],
          [
            1333,
            893
          ],
          [
            1207,
            948
          ],
          [
            1121,
            929
          ],
          [
            1139,
            890
          ]
        ],
        [
          [
            50,
            650
          ],
          [
            100,
            667
          ],
          [
            150,
            685
          ],
          [
            155,
            717
          ],
          [
            126,
            738
          ],
          [
            111,
            732
          ],
          [
            100,
            745
          ],
          [
            71,
            734
          ],
          [
            56,
            718
          ],
          [
            50,
            703
          ]
        ]
      ],
      "smoke": [
        [
          421,
          266
        ],
        [
          699,
          617
        ],
        [
          991,
          416
        ]
      ],
      "landmarks": [
        {
          "id": "lift",
          "label": "The damaged lift",
          "at": [
            336,
            592
          ],
          "text": "The new pin shines. The drum bearing is split. Someone paid for a quick repair and left the weight to everyone below."
        },
        {
          "id": "market",
          "label": "Middle Market",
          "at": [
            944,
            448
          ],
          "text": "The market climbs around a cold public bath. Funeral carts take the eastern road. Their cargo has stopped returning."
        },
        {
          "id": "road",
          "label": "Quiet Kilns \u00b7 eastern road",
          "at": [
            1408,
            400
          ],
          "text": "Nine kilometres along the funeral road. The kiln fires are still burning.",
          "to": "quiet-kilns"
        },
        {
          "id": "to-toll",
          "label": "Toll Stair",
          "at": [
            688,
            656
          ],
          "toBeat": "beat:toll-stair",
          "text": "The workers stair climbs from the quay toward the toll checkpoint."
        },
        {
          "id": "to-court",
          "label": "Reeve's Court",
          "at": [
            1488,
            480
          ],
          "toBeat": "beat:reeves-court",
          "text": "The upper stair reaches the public hearing court."
        },
        {
          "id": "to-lock-foot",
          "label": "Eastern Road and Lock Foot",
          "at": [
            1408,
            400
          ],
          "toBeat": "beat:eastern-road-lock-foot",
          "text": "The maintenance passage meets the eastern road."
        },
        {
          "id": "landing-stair",
          "beatId": "beat:lower-landing",
          "label": "The workers' stair",
          "toBeat": "beat:toll-stair",
          "at": [
            912,
            704
          ],
          "text": "The workers stair climbs from the quay toward the toll checkpoint."
        },
        {
          "id": "landing-boat",
          "beatId": "beat:lower-landing",
          "label": "The canal boat to Nacre Quay",
          "toBeat": "beat:z02-mole-berths",
          "at": [
            272,
            628
          ],
          "text": "Seventy-six kilometres down the canal to the coast."
        },
        {
          "id": "market-stair",
          "beatId": "beat:middle-market-cold-bath",
          "label": "Down the workers stair",
          "toBeat": "beat:toll-stair",
          "at": [
            768,
            508
          ],
          "text": "The workers stair falls toward the toll checkpoint and the quay."
        },
        {
          "id": "market-lift",
          "beatId": "beat:middle-market-cold-bath",
          "label": "Down to the Lift Yard",
          "toBeat": "beat:lift-yard",
          "at": [
            620,
            436
          ],
          "text": "Steps down past the drain to the grain platforms."
        },
        {
          "id": "market-road",
          "beatId": "beat:middle-market-cold-bath",
          "label": "The dry drain to the eastern road",
          "toBeat": "beat:eastern-road-lock-foot",
          "at": [
            1136,
            488
          ],
          "text": "The dry channel runs east under the market to the lock."
        },
        {
          "id": "lift-market",
          "beatId": "beat:lift-yard",
          "label": "Up to the market",
          "toBeat": "beat:middle-market-cold-bath",
          "at": [
            480,
            604
          ],
          "text": "The drain steps climb to the market and the cold bath."
        },
        {
          "id": "lift-court",
          "beatId": "beat:lift-yard",
          "label": "The sluice passage to Reeve's Court",
          "toBeat": "beat:reeves-court",
          "at": [
            400,
            604
          ],
          "text": "The maintenance passage runs up behind the sluices to the court."
        },
        {
          "id": "lift-road",
          "beatId": "beat:lift-yard",
          "label": "The sluice passage to the eastern road",
          "toBeat": "beat:eastern-road-lock-foot",
          "at": [
            364,
            620
          ],
          "text": "The maintenance passage meets the eastern road at the lock."
        }
      ],
      "props": [
        {"id": "z03-torn-screen", "image": "assets/painted/props/z03-torn-screen.png", "at": [483, 246], "height": 89, "depth": 0, "when": {"all": [], "any": [], "none": ["side:bath-screen", "side:sluice-flushed"]}},
        {"id": "z03-patient-screen", "image": "assets/painted/props/z03-patient-screen.png", "at": [483, 246], "height": 89, "depth": 0, "when": {"all": ["side:bath-screen"], "any": [], "none": ["side:sluice-flushed"]}},
        {"id": "z03-bath-bedding", "image": "assets/painted/props/z03-bath-bedding.png", "at": [483, 246], "height": 89, "depth": 0, "when": {"all": ["side:sluice-flushed"], "any": [], "none": []}},
        {"id": "z03-wet-bedding", "image": "assets/painted/props/z03-wet-bedding.png", "at": [556, 406], "height": 89, "depth": 0, "when": {"all": ["side:sluice-flushed"], "any": [], "none": []}},
        {"id": "z03-porter-handcart", "image": "assets/painted/props/z03-porter-handcart.png", "at": [472, 590], "height": 60, "depth": 588, "when": {"all": ["side:arrears-returned"], "any": [], "none": ["side:walkway-shored"]}},
        {"id": "z03-bread-delivery", "image": "assets/painted/props/z03-bread-delivery.png", "at": [815, 481], "height": 91, "depth": 0, "when": {"all": ["side:arrears-returned", "side:walkway-shored"], "any": [], "none": []}}
      ],
      "people": [
        {
          "id": "person:melian",
          "appearance": "actor-melian-sar",
          "name": "Melian Sar \u00b7 speak",
          "route": [
            [
              528,
              624
            ],
            [
              544,
              624
            ]
          ]
        },
        {
          "id": "person:porter",
          "appearance": "actor-kiln-worker",
          "name": "Grain porter",
          "route": [
            [
              240,
              592
            ],
            [
              304,
              592
            ],
            [
              368,
              576
            ]
          ]
        },
        {
          "id": "person:market-worker",
          "appearance": "actor-kiln-worker",
          "name": "Market porter",
          "route": [
            [
              848,
              464
            ],
            [
              912,
              464
            ],
            [
              944,
              448
            ]
          ]
        },
        {
          "id": "person:waiting",
          "appearance": "actor-waiting-family",
          "name": "A waiting family",
          "route": [
            [
              688,
              688
            ],
            [
              672,
              672
            ]
          ]
        },
        {
          "id": "person:road-guard",
          "appearance": "actor-mortuary-guard-rotation",
          "name": "Funeral escort",
          "route": [
            [
              1200,
              320
            ],
            [
              1328,
              368
            ],
            [
              1408,
              400
            ]
          ]
        },
        {"id": "person:bath-displaced", "appearance": "actor-waiting-family", "name": "A family drying their bedding", "route": [[544, 336], [528, 336]], "when": {"all": ["side:sluice-flushed"], "any": [], "none": []}},
        {"id": "person:bread-delivery-worker", "appearance": "actor-kiln-worker", "name": "Unloading the porter handcart", "route": [[928, 464], [944, 464]], "when": {"all": ["side:arrears-returned", "side:walkway-shored"], "any": [], "none": []}},
        {
          "id": "person:quay-worker",
          "appearance": "actor-kiln-worker",
          "name": "Quay hand",
          "route": [
            [
              672,
              656
            ],
            [
              672,
              688
            ],
            [
              720,
              672
            ]
          ]
        }
      ],
      "zone": "Z03",
      "objects": [
        {
          "id": "lower-landing-coffin",
          "beatId": "beat:lower-landing",
          "name": "The closed coffin",
          "at": [
            806,
            676
          ],
          "radius": 28,
          "actions": [
            "coffin",
            "seal-rubbing"
          ],
          "look": "Pine, sealed with wax. It waits on the quay beside the grain nobody will unload."
        },
        {
          "id": "lower-landing-rolls",
          "beatId": "beat:lower-landing",
          "name": "The landing's posted rolls",
          "at": [
            634,
            604
          ],
          "radius": 24,
          "actions": [
            "legacy-record",
            "landing-grave",
            "mystery-book",
            "mystery-dead"
          ],
          "look": "Notices pasted over notices: tariffs, a lost boat, a list of the dead."
        },
        {
          "id": "lower-landing-mooring",
          "beatId": "beat:lower-landing",
          "name": "Where you stepped ashore",
          "at": [
            972,
            826
          ],
          "radius": 22,
          "actions": [
            "landing-return"
          ],
          "look": "Wet stone and a mooring ring. The river brought you in here."
        },
        {
          "id": "lower-landing-canal-boat",
          "beatId": "beat:lower-landing",
          "name": "The canal boat",
          "at": [
            300,
            760
          ],
          "radius": 44,
          "actions": [
            "z02-fare",
            "z02-fare-work"
          ],
          "look": "A long canal boat under a patched sail, bound down to the coast when it has cause."
        },
        {
          "id": "lower-landing-barge",
          "beatId": "beat:lower-landing",
          "name": "The grain barge",
          "at": [
            560,
            760
          ],
          "radius": 40,
          "actions": [],
          "look": "A grain barge rides low at its ropes. No one will unload it."
        },
        {
          "id": "lower-landing-sacks",
          "beatId": "beat:lower-landing",
          "name": "Grain sacks",
          "at": [
            602,
            676
          ],
          "radius": 28,
          "actions": [],
          "look": "Grain for the lift, stacked where the porters left it."
        },
        {
          "id": "lower-landing-sluices",
          "beatId": "beat:lower-landing",
          "name": "The lock sluices",
          "at": [
            1270,
            730
          ],
          "radius": 50,
          "actions": [],
          "look": "The sluices under the eastern road spill white into the river."
        },
        {
          "id": "market-kitchen",
          "beatId": "beat:middle-market-cold-bath",
          "name": "The kitchen stall",
          "at": [
            712,
            392
          ],
          "radius": 30,
          "actions": [
            "kitchen-pay"
          ],
          "look": "Pots on a low fire. The cook feeds whoever the market sends."
        },
        {
          "id": "market-stalls",
          "beatId": "beat:middle-market-cold-bath",
          "name": "The chandler's stall",
          "at": [
            860,
            396
          ],
          "radius": 30,
          "actions": [
            "buy:field-dressing",
            "buy:shield-round",
            "buy:spear-bronze"
          ],
          "look": "Rope, cloth, a few spears and shields for the road."
        },
        {
          "id": "market-drain",
          "beatId": "beat:middle-market-cold-bath",
          "name": "The bath drain",
          "at": [
            560,
            306
          ],
          "radius": 24,
          "actions": [
            "drain",
            "drain-discretion"
          ],
          "look": "A dry channel runs out beneath the bath, behind the treatment alcove."
        },
        {
          "id": "market-screen",
          "beatId": "beat:middle-market-cold-bath",
          "name": "The treatment doorway",
          "at": [
            498,
            262
          ],
          "radius": 26,
          "actions": [
            "bath-screen"
          ],
          "look": "The treatment doorway opens beside the cold bath. What hangs here is all the privacy the patients have."
        },
        {
          "id": "market-bath",
          "beatId": "beat:middle-market-cold-bath",
          "name": "The cold bath",
          "at": [
            708,
            284
          ],
          "radius": 60,
          "actions": [],
          "look": "Cold water under a headless statue. The public bath still runs."
        },
        {
          "id": "lift-drum",
          "beatId": "beat:lift-yard",
          "name": "The lift drum",
          "at": [
            252,
            548
          ],
          "radius": 36,
          "actions": [
            "bearing",
            "buy-bearing",
            "ration",
            "faction-repair"
          ],
          "look": "The new pin shines. The drum bearing is split."
        },
        {
          "id": "lift-tally",
          "beatId": "beat:lift-yard",
          "name": "The tally shelter",
          "at": [
            522,
            560
          ],
          "radius": 26,
          "actions": [
            "tally",
            "tally-shelter",
            "arrears-return",
            "arrears-pocket"
          ],
          "look": "Wage tallies nailed under a little roof, out of the rain."
        },
        {
          "id": "lift-grain",
          "beatId": "beat:lift-yard",
          "name": "The grain heap",
          "at": [
            362,
            578
          ],
          "radius": 34,
          "actions": [
            "porters"
          ],
          "look": "Grain poured from the chute and left where it fell."
        }
      ]
    },
    {
      "id": "quiet-kilns",
      "name": "The Quiet Kilns",
      "image": "/assets/painted/quiet-kilns.webp",
      "width": 1536,
      "height": 1024,
      "spawn": [
        912,
        304
      ],
      "arrival": [
        912,
        304
      ],
      "walkable": [
        [
          [
            380,
            240
          ],
          [
            435,
            237
          ],
          [
            477,
            263
          ],
          [
            540,
            282
          ],
          [
            620,
            292
          ],
          [
            667,
            292
          ],
          [
            707,
            302
          ],
          [
            787,
            287
          ],
          [
            850,
            253
          ],
          [
            889,
            217
          ],
          [
            941,
            217
          ],
          [
            966,
            253
          ],
          [
            1022,
            268
          ],
          [
            1082,
            297
          ],
          [
            1057,
            329
          ],
          [
            969,
            353
          ],
          [
            873,
            359
          ],
          [
            779,
            358
          ],
          [
            684,
            335
          ],
          [
            604,
            332
          ],
          [
            541,
            319
          ],
          [
            479,
            295
          ],
          [
            411,
            281
          ],
          [
            382,
            262
          ]
        ],
        [
          [
            440,
            300
          ],
          [
            499,
            317
          ],
          [
            488,
            352
          ],
          [
            454,
            380
          ],
          [
            450,
            421
          ],
          [
            430,
            450
          ],
          [
            451,
            492
          ],
          [
            472,
            532
          ],
          [
            506,
            573
          ],
          [
            510,
            607
          ],
          [
            543,
            635
          ],
          [
            564,
            665
          ],
          [
            551,
            712
          ],
          [
            513,
            710
          ],
          [
            482,
            673
          ],
          [
            458,
            635
          ],
          [
            439,
            601
          ],
          [
            420,
            563
          ],
          [
            400,
            527
          ],
          [
            389,
            489
          ],
          [
            392,
            442
          ],
          [
            404,
            404
          ],
          [
            404,
            366
          ]
        ],
        [
          [
            511,
            679
          ],
          [
            574,
            654
          ],
          [
            623,
            641
          ],
          [
            656,
            608
          ],
          [
            716,
            600
          ],
          [
            760,
            640
          ],
          [
            808,
            640
          ],
          [
            824,
            608
          ],
          [
            904,
            616
          ],
          [
            936,
            648
          ],
          [
            909,
            700
          ],
          [
            890,
            748
          ],
          [
            830,
            781
          ],
          [
            753,
            815
          ],
          [
            698,
            849
          ],
          [
            639,
            844
          ],
          [
            568,
            812
          ],
          [
            504,
            783
          ],
          [
            473,
            748
          ]
        ]
      ],
      "blocked": [
        [
          [
            685,
            683
          ],
          [
            752,
            665
          ],
          [
            819,
            695
          ],
          [
            816,
            741
          ],
          [
            770,
            766
          ],
          [
            696,
            742
          ]
        ],
        [
          [
            653,
            747
          ],
          [
            697,
            736
          ],
          [
            732,
            755
          ],
          [
            735,
            781
          ],
          [
            687,
            788
          ],
          [
            651,
            772
          ]
        ],
        [
          [
            517,
            533
          ],
          [
            598,
            552
          ],
          [
            632,
            582
          ],
          [
            630,
            635
          ],
          [
            553,
            659
          ],
          [
            518,
            626
          ]
        ]
      ],
      "foregrounds": [
        {
          "polygon": [
            [
              335,
              701
            ],
            [
              382,
              671
            ],
            [
              414,
              678
            ],
            [
              418,
              718
            ],
            [
              446,
              740
            ],
            [
              480,
              753
            ],
            [
              482,
              786
            ],
            [
              529,
              789
            ],
            [
              544,
              815
            ],
            [
              589,
              844
            ],
            [
              629,
              863
            ],
            [
              667,
              871
            ],
            [
              672,
              906
            ],
            [
              598,
              890
            ],
            [
              551,
              863
            ],
            [
              483,
              832
            ],
            [
              436,
              807
            ],
            [
              380,
              779
            ],
            [
              339,
              751
            ]
          ],
          "depth": 867
        },
        {
          "polygon": [
            [
              685,
              683
            ],
            [
              752,
              665
            ],
            [
              819,
              695
            ],
            [
              816,
              741
            ],
            [
              770,
              766
            ],
            [
              696,
              742
            ]
          ],
          "depth": 747
        },
        {
          "polygon": [
            [
              653,
              747
            ],
            [
              697,
              736
            ],
            [
              732,
              755
            ],
            [
              735,
              781
            ],
            [
              687,
              788
            ],
            [
              651,
              772
            ]
          ],
          "depth": 790
        },
        {
          "polygon": [
            [
              612,
              718
            ],
            [
              618,
              714
            ],
            [
              627,
              713
            ],
            [
              636,
              716
            ],
            [
              639,
              720
            ],
            [
              638,
              741
            ],
            [
              634,
              747
            ],
            [
              625,
              750
            ],
            [
              617,
              747
            ],
            [
              613,
              741
            ]
          ],
          "depth": 751
        }
      ],
      "lamps": [
        [
          580,
          260
        ],
        [
          566,
          477
        ],
        [
          726,
          521
        ],
        [
          901,
          558
        ],
        [
          48,
          463
        ],
        [
          250,
          382
        ],
        [
          177,
          984
        ],
        [
          364,
          962
        ],
        [
          1274,
          154
        ],
        [
          1504,
          267
        ],
        [
          1215,
          320
        ],
        [
          1208,
          508
        ],
        [
          1217,
          850
        ],
        [
          1222,
          756
        ],
        [
          1293,
          908
        ]
      ],
      "water": [
        [
          [
            752,
            235
          ],
          [
            779,
            214
          ],
          [
            856,
            221
          ],
          [
            861,
            238
          ],
          [
            792,
            281
          ],
          [
            757,
            288
          ]
        ]
      ],
      "smoke": [
        [
          52,
          424
        ],
        [
          247,
          347
        ],
        [
          578,
          248
        ],
        [
          185,
          510
        ],
        [
          175,
          650
        ],
        [
          236,
          870
        ]
      ],
      "landmarks": [
        {
          "id": "court",
          "label": "Cooling Court",
          "at": [
            912,
            304
          ],
          "text": "Urns wait on the pottery shelves. Nine names in the burial register have no matching remains."
        },
        {
          "id": "gallery",
          "label": "Lower Work Gallery",
          "at": [
            608,
            752
          ],
          "text": "The tethered body sorts the same pieces again. Its joints do not move like living joints. This is labour imposed on the dead."
        },
        {
          "id": "return",
          "label": "Return to the Silt Stair",
          "at": [
            416,
            256
          ],
          "text": "The funeral road returns to the canal. The lift is still waiting for a bearing.",
          "to": "silt-stair"
        },
        {
          "id": "to-cooling",
          "label": "Cooling Court",
          "at": [
            528,
            688
          ],
          "toBeat": "z04-cooling-court",
          "text": "The stone stair returns to the waiting families."
        },
        {
          "id": "to-sela",
          "label": "Sela's Preparation Rooms",
          "at": [
            848,
            736
          ],
          "toBeat": "z04-selas-rooms",
          "text": "A lantern marks the narrow preparation-room passage."
        },
        {
          "id": "to-cut",
          "label": "The Dry Cut",
          "at": [
            544,
            752
          ],
          "toBeat": "z04-dry-cut",
          "text": "Beyond the lower arch, an old dry channel cuts through the limestone."
        }
      ],
      "people": [
        {
          "id": "person:kiln-family",
          "appearance": "actor-waiting-family",
          "name": "A waiting family",
          "route": [
            [
              976,
              320
            ],
            [
              944,
              304
            ]
          ]
        },
        {
          "id": "person:kiln-porter",
          "appearance": "actor-kiln-worker",
          "name": "Potter",
          "route": [
            [
              560,
              304
            ],
            [
              640,
              304
            ],
            [
              688,
              320
            ]
          ]
        },
        {
          "id": "person:working-dead",
          "appearance": "actor-working-dead",
          "name": "The tethered dead",
          "route": [
            [
              672,
              688
            ],
            [
              672,
              704
            ]
          ]
        },
        {
          "id": "person:kiln-table-worker",
          "appearance": "actor-kiln-worker",
          "name": "Clay worker",
          "route": [
            [
              568,
              688
            ],
            [
              608,
              672
            ],
            [
              640,
              704
            ]
          ]
        }
      ],
      "objects": [
        {
          "id": "gallery-tally-stand",
          "beatId": "z04-lower-work-gallery",
          "name": "The tally stand",
          "at": [
            760,
            728
          ],
          "radius": 40,
          "actions": [
            "gallery",
            "gallery-stopped"
          ],
          "look": "Tally pieces stacked by the dozen, and a notice nailed to the stand."
        },
        {
          "id": "gallery-anchor",
          "beatId": "z04-lower-work-gallery",
          "name": "The gallery anchor",
          "at": [
            628,
            736
          ],
          "radius": 34,
          "actions": [
            "tether-gallery",
            "tether-gallery-remains",
            "gallery-release"
          ],
          "look": "A chalk ring on the floor, and wax set out in numbered order inside it."
        }
      ],
      "zone": "Z04"
    }
  ]
}
